<!-- eslint-disable no-undef -->
<script>
/**
 * ****************************************************************************
 * @description     :   Input DatePicker Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import moment from 'moment';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input datepicker component
 */
var AnsDatePicker = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        placeholder: String,
        value: String,
        modelValue: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        isMonthYear: {
            type: Boolean,
            default: false
        },
        onChangeEvent: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: this.id && this.id != '' ? this.id : _.uuid(),
            dateId: _.uuid(),
            buttonId: _.uuid(),
            count: 0
        };
    },
    computed: {
        vewValue: {
            get() {
                return this.getValue(
                    this.modelValue ? this.modelValue : this.value
                );
            },
            set() {}
        }
    },
    watch: {
        modelValue() {
            setTimeout(() => {
                $(`#${this.dateId}`).datepicker('update');
            }, 100);
        },
        value() {
            setTimeout(() => {
                $(`#${this.dateId}`).datepicker('update');
            }, 100);
        },
        isMonthYear() {
            $(`#${this.dateId}`).datepicker('remove');
            this.initPicker();
        }
    },
    mounted() {
        this.initPicker();
    },
    methods: {
        initPicker() {
            $(`#${this.dateId}`).datepicker({
                format: this.isMonthYear ? 'yyyy/mm' : 'yyyy/mm/dd',
                language: 'ja',
                minViewMode: this.isMonthYear ? 1 : 0,
                autoclose: true
            });
            $(`#${this.dateId}`)
                .datepicker()
                .on('show', () => {
                    $(`#${this.dateId}`).addClass('active');
                });
            $(`#${this.dateId}`)
                .datepicker()
                .on('hide', () => {
                    $(`#${this.dateId}`).removeClass('active');
                });
            if (this.isMonthYear) {
                $(`#${this.dateId}`).on('changeMonth', this.pickValue);
            } else {
                $(`#${this.dateId}`).on('changeDate', this.pickValue);
            }
        },
        clickShowCalendar() {
            $(`#${this.dateId}`).datepicker('show');
        },
        /**
         * event keydown on input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/07/20 - create
         * @params :
         * @access : private
         */
        inputKeydown(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 13 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 191
                )
            ) {
                e.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * Check date type for input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/07/20 - create
         * @params : value
         * @access : private
         */
        isDate(string) {
            if (string == '') {
                return true;
            }
            if (string.length == 8) {
                string =
                    string.substring(0, 4) +
                    '/' +
                    string.substring(4, 6) +
                    '/' +
                    string.substring(6);
            }
            var reg =
                /^((19|[2-9][0-9])[0-9]{2})[/.](0[13578]|1[02])[/.]31|((19|[2-9][0-9])[0-9]{2}[/.](01|0[3-9]|1[0-2])[/.](29|30))|((19|[2-9][0-9])[0-9]{2}[/.](0[1-9]|1[0-2])[/.](0[1-9]|1[0-9]|2[0-8]))|((((19|[2-9][0-9])(04|08|[2468][048]|[13579][26]))|2000)[/.](02)[/.]29)$/;
            if (string.match(reg)) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * convert date for input datepiker
         * -----------------------------------------
         * @author : QuyPN - 2023/07/20 - create
         * @params : value
         * @access : private
         */
        convertDateString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^[0-9]{4}(1[0-2]|0[1-9])(3[0-1]|[1-2][0-9]|0[1-9])$/;
            var reg2 =
                /^[0-9]{4}[/.](1[0-2]|0[1-9])[/.](3[0-1]|[1-2][0-9]|0[1-9])$/;
            var reg3 = /^[0-9]{4}(1[0-2]|0[1-9])$/;
            var reg4 = /^[0-9]{4}[/.](1[0-2]|0[1-9])$/;
            if (value.match(reg1)) {
                value =
                    value.substring(0, 4) +
                    '/' +
                    value.substring(4, 6) +
                    '/' +
                    value.substring(6);
            }
            if (value.match(reg3)) {
                value =
                    value.substring(0, 4) + '/' + value.substring(4, 6) + '/01';
            }
            if (value.match(reg4)) {
                value = value + '/01';
            }
            if (!value.match(reg2)) {
                value = '';
            }
            if (!this.isDate(value)) {
                value = '';
            }
            return value;
        },
        /**
         * convert year/month for input datepicker
         * -----------------------------------------
         * @author : QuyPN - 2023/07/20 - create
         * @params : value
         * @access : private
         */
        convertYearMonthString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^[0-9]{4}(1[0-2]|0[1-9])$/;
            var reg2 = /^[0-9]{4}[/.](1[0-2]|0[1-9])$/;
            var reg3 = /^[0-9]{4}(1[0-2]|0[1-9])(3[0-1]|[1-2][0-9]|0[1-9])$/;
            var reg4 =
                /^[0-9]{4}[/.](1[0-2]|0[1-9])[/.](3[0-1]|[1-2][0-9]|0[1-9])$/;
            if (value.match(reg1) || value.match(reg3)) {
                value = value.substring(0, 4) + '/' + value.substring(4, 6);
            }
            if (value.match(reg4)) {
                value = value.substring(0, 7);
            }
            if (!value.match(reg2)) {
                value = '';
            }
            return value;
        },
        getValue(input) {
            let val = '';
            if (this.isMonthYear) {
                val = this.convertYearMonthString(input);
            } else {
                val = this.convertDateString(input);
            }
            return val;
        },
        pickValue(e) {
            this.changeModel(
                moment(e.date).format(
                    this.isMonthYear ? 'YYYY/MM' : 'YYYY/MM/DD'
                )
            );
            this.$refs.inputDate?.focus();
        },
        updateValue(e) {
            const val = e.target.value.replace(/\D/g, '');
            this.changeModel(this.getValue(val));
            this.count++;
        },
        changeModel(val) {
            if ((this.vewValue ?? '') != (val ?? '')) {
                $('#' + this.newId).RemoveError();
                this.$emit('update:modelValue', val);
                if (this.onChangeEvent) {
                    setTimeout(() => {
                        this.onChangeEvent(val);
                    }, 100);
                }
            }
        },
        focusItem() {
            this.$refs.inputDate?.focus();
        }
    }
};
export default AnsDatePicker;
</script>
